window.initGallery = function(){
    var els = $('.gallery');
    //console.log('init');
    $.each(els, function(){
        var items = $(this).data('items');
        $(this).find('a').click(function(){
            //console.log('click');
            var options = {
                index: $(this).data('index'),
                addCaptionHTMLFn: function(item, captionEl, isFake) {
                    if(!item.title) {
                        captionEl.children[0].innerText = '';
                        return false;
                    }
                    var caption = item.title;
                    if(item.author){
                        caption += '<br /><small>Fot. ' + item.author + '</small>'
                    }
                    captionEl.children[0].innerHTML = caption;
                    return true;
                },
            };
            //console.log($(this).data('index'));
            var gallery = new PhotoSwipe(
                document.querySelectorAll('.pswp')[0],
                PhotoSwipeUI_Default,
                items,
                options
            );
            gallery.init();
            return false;
        });
    });
}


// WEBPACK FOOTER //
// ./Resources/assets/js/news.js